import EnumItem from '../../../common/utils/Enum'
import { i18n } from '../../../common/utils/i18n'

export const params = new EnumItem({
  shopDetailEsc: { value: 'esc', text: 'esc' },
  shopDetailCompanyFail: { value: 'company-fail', text: i18n.gettext('公司公证') },
  shopDetailCnpj: { value: 'cnpj', text: i18n.gettext('CNPJ') },
  shopDetailBusinessCertificate: {
    value: 'business-certificate',
    text: i18n.gettext('市政经营许可证'),
  },
  shopDetailHealthyCertificate: {
    value: 'healthy-certificate',
    text: i18n.gettext('卫生安全通知'),
  },
  shopDetailLandUseCertificate: {
    value: 'land-use-certificate',
    text: i18n.gettext('土地使用许可证'),
  },
  shopDetailWineSoldCertificate: {
    value: 'wine-sold-certificate',
    text: i18n.gettext('酒精销售许可证'),
  },
  shopDetailLegalPerson: { value: 'legal-person', text: i18n.gettext('法人信息') },
  shopDetailAuthorization: { value: 'authorization', text: i18n.gettext('结算信息') },
  shopDetailContractInfo: { value: 'contract-info', text: i18n.gettext('合同信息') },
  shopDetailContractPic: { value: 'contract-pic', text: i18n.gettext('合同照片') },
  shopDetailContractRecord: { value: 'contract-record', text: i18n.gettext('合同记录') },
  shopDetailSignSettleInfo: { value: 'sign-settle-info', text: i18n.gettext('签字授权书') },
  shopDetailRemitSettleInfo: { value: 'remit-settle-info', text: i18n.gettext('打款授权书') },
  shopDetailOtherDish: { value: 'other-dish', text: i18n.gettext('菜单') },
  shopDetailOtherEmail: { value: 'other-email', text: i18n.gettext('审批邮件') },
  shopDetailOtherBankflow: { value: 'other-bankflow', text: i18n.gettext('银行流水单') },
  shopDetailOtherExtra: { value: 'other-extra', text: i18n.gettext('其他') },
  shopDetailTaxInfo: { value: 'tax-info', text: i18n.gettext('纳税信息') },
  shopDetailStartupMoney: { value: 'startup-money', text: i18n.gettext('启动费') },
  shopDetailEquipmentInfo: { value: 'equipment-info', text: i18n.gettext('设备信息') },
  giveUpBizopp: { value: 'giveup-bizopp', text: i18n.gettext('放弃原因') },
  salesData: { value: 'sales-data', text: i18n.gettext('销售数据') },
})

export default {
  shopDetail: '/shop-detail',
  bizoppDetail: '/bizopp-detail',
  shopDetailMapView: '/shop-detail/map-view',
  shopDetailBaseDetail: '/shop-detail/base-detail',
  shopDetailList: '/shop-detail/list/',
  shopDetailListDetail: '/shop-detail/list/page/',
  shopDetailGallery: '/shop-detail/gallery',
  modifyBussiness: '/edit-bizopp',
  applySign: '/sign/', // 申请签约
  editSign: '/sign/', // 编辑签约材料
  viewContractMaterials: '/sign/', // 查看签约材料
  UploadDishesPictures: '/', // 上传菜品图片
  foodPicturesApproval: '/', // 查看菜品图片审批
  404: '/404',
  addVisit: 'add-visit', // 添加拜访记录
  editBusiInfo: '/edit-busi-info', // 编辑经营信息
  giveUpBizopp: '/giveup-bizopp', // 放弃商机
  salesData: '/shop-detail/sales-data', // 销售数据
  poiErrReport: '/shop-detail/poi-err-report', // 商家位置错误上报
}
